import React from 'react';
import logo from './logo.svg';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NavigationBar from './NavBar';
import { Container } from 'react-bootstrap';
import './App.css';
import Home from './home/Home';
import EmailVerification from './email-verification/EmailVerification';

function App() {
  return (
    <Router>
      <NavigationBar />
      <div className="router-container">
        <Container fluid>
          <Routes>
            <Route path="/email/verification/:code?/:game?" element={<EmailVerification />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Container>
      </div>
    </Router>
  );
}

export default App;
